<template>
  <ModalStructure
    class="modal"
    shouldCloseOnBlur
    :showModal="showModal"
    showCloseButton
    @close="handleClose"
  >
    <template v-slot:header>
      <HeadingMedium>
        {{ headerText }}
      </HeadingMedium>
    </template>
    <template v-slot:body>
      <Container
        class="contentContainer"
      >
        <img
          :alt="imageData.alt"
          class="modalImage"
          :src="imageData.src"
        >
        <ParagraphBody class="paragraphBody">
          {{ modalText }}
          <span class="actionText">
            Do you want to enable it now for all supported resources?
          </span>
        </ParagraphBody>
        <ParagraphBody>
          <Link
            :href="kbLink.href"
            isExternal
            target="_blank"
            :text="kbLink.text"
          />
        </ParagraphBody>
      </Container>
    </template>
    <template v-slot:footer>
      <footer>
        <Button
          class="primaryButton"
          text="Enable"
          type="primary"
          @click="handleContinue"
        />

        <ButtonSecondary
          text="Cancel"
          @click="handleClose"
        />
      </footer>
    </template>
  </ModalStructure>
</template>

<script>
import {
  Button,
  ButtonSecondary,
  Container,
  HeadingMedium,
  Link,
  ModalStructure,
  ParagraphBody,
} from '@jumpcloud/ui-components';

export default {
  name: 'EnableFactorModalView',

  components: {
    Button,
    ButtonSecondary,
    Container,
    HeadingMedium,
    ModalStructure,
    Link,
    ParagraphBody,
  },

  props: {
    handleContinue: {
      type: Function,
      required: true,
    },
    headerText: {
      type: String,
      required: true,
    },
    imageData: {
      type: Object,
      required: true,
    },
    kbLink: {
      type: Object,
      required: true,
    },
    modalText: {
      type: String,
      required: true,
    },
    showModal: {
      type: Boolean,
      required: true,
    },
  },

  methods: {
    handleClose() {
      this.$emit('close-modal');
    },
  },
};
</script>

<style scoped>
.modal {
  --modal-width: 38em;
}

.contentContainer {
  --container-padding: 2em 0 1em 0;
}

.modalImage {
  display: block;
  height: 20em;
  margin: 1.5em auto;
}

.actionText {
  font-weight: 700;
}

.primaryButton {
  margin-right: 0.5em;
}
</style>
